import { useCallback } from 'react';

import { Toast } from '../../../components/toast/toast';
import { userApi } from '../../../services/users';

type Params = {
    operatorId: number;
    accessToken?: string;
};

const useOperatorDetails = ({ operatorId, accessToken }: Params) => {
    const updateRole: (roleId: number) => Promise<boolean> = useCallback(
        async (roleId) => {
            if (!accessToken) return false;

            Toast.show({ text: 'Actualizando...', type: 'info' });

            const response = await userApi.admin.updateOperatorRole(
                {
                    operatorId: operatorId,
                    newRole: roleId,
                },
                { auth: { token: accessToken } }
            );
            if (!response) {
                Toast.show({
                    text: 'Error actualizando rol',
                    type: 'error',
                });
                return false;
            }
            Toast.show({ text: 'Rol actualizado', type: 'info' });
            return true;
        },
        [accessToken]
    );

    return {
        updateRole,
    };
};

export { useOperatorDetails };
